import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3e4992b8")
const _hoisted_1 = { class: "legendContainer" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4], (index) => {
        return _createElementVNode("div", {
          key: index,
          class: "legendItem"
        }, [
          _createElementVNode("span", {
            style: _normalizeStyle(_ctx.legend[index].iconCSS)
          }, null, 4),
          _createTextVNode(" " + _toDisplayString(_ctx.legend[index].text), 1)
        ])
      }), 64))
    ])
  ]))
}